import { Injectable } from '@angular/core';
import { QueryObject, QueryResult, SqlServerModel } from './ngx-query-editor.models' ;
import { Observable } from 'rxjs';

@Injectable()
export abstract class NgxQueryEditorAbstractService {

  public queryExecuted = true;

  public abstract executeQuery(query: QueryObject): Observable<QueryResult>;
  public abstract getCollectionSchema(collectionName: string, dbName: string): Observable<any[]>;
  public abstract getSqlServerById(sqlServerId: string): Observable<SqlServerModel>;
}
